// extracted by mini-css-extract-plugin
module.exports = {"cardmsgC":"cardmsgC_cardmsgC__3VJy0"};